export const COMMENTS_EN = {
    'nav.module.comments': 'Comments',
    'entity.comments.subject': 'comments',
    'comments.subject_comments.title': 'Comments',
    'comments.card.empty': 'No comment yet.',
    'comments.col.body': 'Comment',
    'comments.col.author_name': 'By',
    'comments.col.created_at': 'When',
    'comments.col.mentioned': 'Mentioned',
    'comments.col.id': 'Id',
    'comments.col.can_edit': 'Can edit',
    'comments.col.can_withdraw': 'Can withdraw',
    'comments.action.post': 'Comment',
    'comments.action.edit': 'Edit',
    'comments.action.withdraw': 'Withdraw',
    'comments.field.body': 'Comment',
    'comments.field.mentions': 'Tell',
    'comments.field.mentions.help': 'Each member you choose is told of this comment.',
    'comments.field.mentions.edit_help': 'Members named for the first time are told; the others are not told again.',
    'comments.refusal.subject': 'This is not a record a comment can be kept on.',
    'comments.refusal.not_found': 'There is no such record, or it is not yours to read.',
    'comments.refusal.unknown_entity': 'Comments cannot be kept on this kind of record.',
    'comments.refusal.access_unavailable': 'Who may read this record could not be checked just now. Nothing was changed; try again.',
    'comments.refusal.body_required': 'Write the comment.',
    'comments.refusal.not_text': 'This must be text.',
    'comments.refusal.too_long': 'At most {max} characters.',
    'comments.refusal.mentions': 'Choose members from the list.',
    'comments.refusal.too_many_mentions': 'At most {max} members can be named in one comment.',
    'comments.refusal.not_a_member': 'Only a member of this workspace can be named.',
    'comments.refusal.members_unavailable': 'The workspace\'s members could not be listed just now. Post it without naming anybody, or try again.',
    'comments.refusal.may_not_name': 'Naming members needs permission to see the workspace\'s members. Post it without naming anybody.',
    'comments.refusal.not_yours': 'Only its author edits a comment; its author or a moderator withdraws it.',
    'comments.refusal.withdrawn': 'This comment was withdrawn.',
    'comments.refusal.stale': 'Somebody changed this comment since you opened it. Reload and try again.',
    'change.field.comment.subject_entity': 'Record type',
    'change.field.comment.subject_id': 'Record',
    'change.field.comment.body': 'Comment',
    'change.field.comment.mentions': 'Mentioned',
    'change.field.comment.mention_names': 'Mentioned (names)',
    'change.field.comment.author_user': 'Author',
    'change.field.comment.author_name': 'Author (name)',
    'change.field.comment.edited_at': 'Edited',
    'change.field.comment.status': 'State',
    'change.field.comment.withdrawn_at': 'Withdrawn',
    'change.field.comment.withdrawn_by': 'Withdrawn by',
    'change.field.comment.created_by': 'Written by',
};
export const COMMENTS_AR = {
    'nav.module.comments': 'التعليقات',
    'entity.comments.subject': 'التعليقات',
    'comments.subject_comments.title': 'التعليقات',
    'comments.card.empty': 'لا تعليق بعد.',
    'comments.col.body': 'التعليق',
    'comments.col.author_name': 'كتبه',
    'comments.col.created_at': 'متى',
    'comments.col.mentioned': 'المذكورون',
    'comments.col.id': 'المعرّف',
    'comments.col.can_edit': 'يمكن تعديله',
    'comments.col.can_withdraw': 'يمكن سحبه',
    'comments.action.post': 'علّق',
    'comments.action.edit': 'تعديل',
    'comments.action.withdraw': 'سحب',
    'comments.field.body': 'التعليق',
    'comments.field.mentions': 'أبلِغ',
    'comments.field.mentions.help': 'يُبلَّغ كل عضو تختاره بهذا التعليق.',
    'comments.field.mentions.edit_help': 'يُبلَّغ من يُذكر أول مرة فقط؛ ولا يُبلَّغ الآخرون مرة أخرى.',
    'comments.refusal.subject': 'هذا ليس سجلًّا يمكن التعليق عليه.',
    'comments.refusal.not_found': 'لا يوجد هذا السجل، أو ليس لك أن تطّلع عليه.',
    'comments.refusal.unknown_entity': 'لا يمكن التعليق على هذا النوع من السجلات.',
    'comments.refusal.access_unavailable': 'تعذّر الآن التحقق ممن يحق له رؤية هذا السجل. لم يتغيّر شيء؛ حاول مرة أخرى.',
    'comments.refusal.body_required': 'اكتب التعليق.',
    'comments.refusal.not_text': 'يجب أن يكون نصًّا.',
    'comments.refusal.too_long': 'بحدّ أقصى {max} حرفًا.',
    'comments.refusal.mentions': 'اختر الأعضاء من القائمة.',
    'comments.refusal.too_many_mentions': 'يمكن ذكر {max} عضوًا على الأكثر في تعليق واحد.',
    'comments.refusal.not_a_member': 'لا يُذكر إلا عضو في مساحة العمل هذه.',
    'comments.refusal.members_unavailable': 'تعذّر الآن عرض أعضاء مساحة العمل. انشره دون ذكر أحد، أو حاول مرة أخرى.',
    'comments.refusal.may_not_name': 'ذكر الأعضاء يحتاج إلى صلاحية رؤية أعضاء مساحة العمل. انشره دون ذكر أحد.',
    'comments.refusal.not_yours': 'لا يعدّل التعليق إلا كاتبه، ولا يسحبه إلا كاتبه أو المشرف.',
    'comments.refusal.withdrawn': 'سُحب هذا التعليق.',
    'comments.refusal.stale': 'غيّر أحدٌ هذا التعليق بعد أن فتحته. أعد التحميل وحاول مرة أخرى.',
    'change.field.comment.subject_entity': 'نوع السجل',
    'change.field.comment.subject_id': 'السجل',
    'change.field.comment.body': 'التعليق',
    'change.field.comment.mentions': 'المذكورون',
    'change.field.comment.mention_names': 'أسماء المذكورين',
    'change.field.comment.author_user': 'الكاتب',
    'change.field.comment.author_name': 'اسم الكاتب',
    'change.field.comment.edited_at': 'عُدّل في',
    'change.field.comment.status': 'الحالة',
    'change.field.comment.withdrawn_at': 'سُحب في',
    'change.field.comment.withdrawn_by': 'سحبه',
    'change.field.comment.created_by': 'كتبه',
};
//# sourceMappingURL=i18n-comments.js.map